<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="static/img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="static/img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3">Dashboard</b-nav-item>
        <b-nav-item class="px-3">Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" />
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid" >
          <router-view></router-view>

        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DafaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
    </TheFooter>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import nav from '../_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DafaultAside from './DafaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'


export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DafaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
 
  },
  data () {
    return {
      nav: nav.items,
      // contents:{
      //   // Text Input
      //   FITTextInput:{value:'',label:'Name', type:'text', placeholder:"Please Enter Your Name", initValue:'initValue String', width:10,disabled:false},
      //   // Checkbox
      //   FITCheckbox:{value:'',label:"FITCheckbox", trueString:"true", falseString:"false",initValue:true, disabled:false },
      //    // Textarea
      //   FITTextarea:{value:'', label:"FITTextarea",placeholder:'Left your message here',initValue:'',width:10,rows:3,maxRows:6, disabled:false  },
      //   // Checkbox Group
      //   FITCheckboxGroup:{
      //   value:[], initValue:['orange','grape'], label:"FITCheckboxGroup", stacked:false, width: 10,  disabled:false,
      //   options: [
      //   {text: 'Orange', value: 'orange'},
      //   {text: 'Apple', value: 'apple'},
      //   {text: 'Pineapple', value: 'pineapple',disabled:true},
      //   {text: 'Grape', value: 'grape'}
      //   ]
      //   },
      //   // Radio
      //   FITRadio:{
      //   value:'', initValue:'apple', label:"FITRadio",stacked:true, width: 10, disabled:false,
      //   options: [
      //   {text: 'Orange', value: 'orange'},
      //   {text: 'Apple', value: 'apple'},
      //   {text: 'Pineapple', value: 'pineapple',disabled:true},
      //   {text: 'Grape', value: 'grape'}
      //   ]
      //   }, 
      //   // Select
      //   FITSelect:{
      //   value:'',initValue:'grape',label:"FITSelect", width: 10, disabled:false, selectSize:1,
      //   options: [
      //   {text: 'Orange', value: 'orange'},
      //   {text: 'Apple', value: 'apple'},
      //   {text: 'Pineapple', value: 'pineapple',disabled:true},
      //   {text: 'Grape', value: 'grape'}
      //   ]
      //   },



















      // },
      // checkbox:true,
      // radioGroup:"",
      // textInput:"",
      // textarea:"",
    }
  },
  watch:{
  
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  methods:{
    // father_method: (asd) => {
    //   console.log("father");
    //   console.log(asd);
    // }
  }
}


</script>


// WEBPACK FOOTER //
// src/containers/DefaultContainer.vue